import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["aria-selected"]
const _hoisted_2 = ["aria-selected"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WalletRequisites = _resolveComponent("WalletRequisites")!
  const _component_SharedWindow = _resolveComponent("SharedWindow")!

  return (_openBlock(), _createBlock(_component_SharedWindow, {
    title: "Вывод",
    isBig: _ctx.isBig,
    "is-center": true,
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('intro'))
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('subtitle'))
        }, _toDisplayString(_ctx.$t("Средства уйдут на указанные реквизиты")), 3),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('tabs')),
          role: "tablist"
        }, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(_ctx.b('tab', { active: _ctx.tab === _ctx.currencyTypes.fiat })),
            role: "tab",
            "aria-selected": _ctx.tab === _ctx.currencyTypes.fiat,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleTab(_ctx.currencyTypes.fiat)))
          }, " Fiat ", 10, _hoisted_1),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(_ctx.b('tab', { active: _ctx.tab === _ctx.currencyTypes.crypto })),
            role: "tab",
            "aria-selected": _ctx.tab === _ctx.currencyTypes.crypto,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleTab(_ctx.currencyTypes.crypto)))
          }, " Crypto ", 10, _hoisted_2)
        ], 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('wrapper'))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('header'))
        }, [
          _createVNode(_component_WalletRequisites, {
            requisite: _ctx.requisite,
            "onUpdate:requisite": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.requisite) = $event))
          }, null, 8, ["requisite"])
        ], 2),
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.displayedComponent)))
      ], 2)
    ]),
    _: 1
  }, 8, ["isBig", "onClose"]))
}